import { render, staticRenderFns } from "./market.vue?vue&type=template&id=90763f68&scoped=true"
import script from "./market.vue?vue&type=script&lang=js"
export * from "./market.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90763f68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90763f68')) {
      api.createRecord('90763f68', component.options)
    } else {
      api.reload('90763f68', component.options)
    }
    module.hot.accept("./market.vue?vue&type=template&id=90763f68&scoped=true", function () {
      api.rerender('90763f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/market.vue"
export default component.exports